<h1 matDialogTitle>{{title}}</h1>
<div mat-dialog-content class="font-size-confirm">{{confirmMessage}}</div>
<div mat-dialog-content class="font-size-sub p-10" *ngIf="subMessage.length > 0">{{subMessage}}</div>
<div mat-dialog-actions class="p-24" fxLayoutAlign="center center">
    <button *ngIf="isConfirmar" mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(true)">{{confirmarButton}}</button>
    <button *ngIf="isCancelar" mat-button class="red" (click)="dialogRef.close(false)">{{cancelarButton}}</button>
</div>